import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { ApparelArticleMaster } from "../entities/tech-pack/apparel-article-master.entity";


@Injectable()
export class ApparelArticleMasterRepo extends Repository<ApparelArticleMaster> {

    constructor(@InjectRepository(ApparelArticleMaster) private apparelArticleMasterRepo: Repository<ApparelArticleMaster>
    ) {
        super(apparelArticleMasterRepo.target, apparelArticleMasterRepo.manager, apparelArticleMasterRepo.queryRunner);
    }

}